import Request from '../../../../src/core/gd/data/request'
import {SystemStatus} from "../const/system-status"
import {ProjectSystemType} from "../../model2/project/types"
import ProjectView from "../../model2/project-view/project-view"
import {UniversalTaskSelectorSystemStatus} from "../manager/universal-task-selector/universal-task-selector";

export default class ApiProject {

    constructor() {

    }

    // NEW
    static info(projectId:ID) {
        return new Request(this,'GET','project/'+projectId+'/info')
    }

    // static convertToWorkspace(projectId:ID) {
    //     return new Request(this,'PUT','project/'+projectId+'/convert-v2', {
    //         systemType      : ProjectSystemType.WORKSPACE
    //     })
    // }

    static newWorkspace(data:any) {
        return new Request(this,'post','new/workspace',data);
    }

    static newTag(data:any) {
        return new Request(this,'post','new-tag',data);
    }

    static loadProjectUsers(projectId:ID) {
        return new Request(this,'GET','project/'+projectId+'/users-recursively')
    }

    static updateNew(projectId:ID, params:any) {
        return new Request(this,'PUT','project/{0}/update'.f(projectId), params);
    }

    static applyColorToChildren(projectId:ID) {
        return new Request(this,'POST','project/{0}/apply-color-to-children'.f(projectId))
    }

    // do we need it ?
    static newStructure(params: {
        parentProjectId?    : ID
        name                : string
        systemType          : ProjectSystemType
        color?              : number
        ownerUserId?        : ID
        settings?           : any
        properties?         : any
        projectIcon?        : string
    }) {
        return new Request(this,'POST','new/structure',params)
    }

    static newView(params: {
        parentProjectId?    : ID
        name                : string
        color?              : number
        projectIcon?        : string
        properties?         : JSONObject
        settings            : JSONObject
    }) {
        return new Request(this,'POST','new/structure-view',params)
    }

    static newReportView(params: {
        parentProjectId?    : ID
        name                : string
        color?              : number
        projectIcon?        : string
        properties?         : JSONObject
        settings            : JSONObject
    }) {
        return new Request(this,'POST','new/structure-report-view',params)
    }

    static newPage(params: {
        companyId?          : ID
        parentProjectId?    : ID
        name                : string
        color?              : number
        projectIcon?        : string
        isTemplate          : boolean
    }) {
        if (!params.companyId) params.companyId = gd.companyId

        return new Request(this,'POST','new/page',params)
    }

    static newGroup(params: {
        parentProjectId?    : ID
        name                : string
        color?              : number
    }) {
        return new Request(this,'POST','new/group',params)
    }

    static newLink(params: {
        parentProjectId?    : ID
        name                : string
        color?              : number
        url                 : string
    }) {
        return new Request(this,'POST','new/link',params)
    }

    static newEmbed(params: {
        parentProjectId?    : ID
        name                : string
        color?              : number
        embedCode           : string
    }) {
        return new Request(this,'POST','new/embed',params)
    }

    // static newView(projectId: ID, params: { name        : string, systemType  : ViewType }) {
    //     return new Request(this,'POST','project/{0}/view'.f(projectId), params)
    // }

    static updateView(projectView: ProjectView, payload:any ) {
        const settings = projectView.projectViews.project.settings?.toJSON() || {}
        settings.views = projectView.projectViews.project.getInheritedViews()

        // hitrii hack - this is project settings (!)
        payload['settings'] = settings // we pass settings because at the moment views are calculated on client only (!) and server need them to add a view

        return new Request(this,'PUT','project/{0}/view/{1}'.f(projectView.projectViews.project.id, projectView.id), payload)
    }

    static addView(projectView: ProjectView ) {
        const settings = projectView.projectViews.project.settings?.toJSON() || {}
        settings.views = projectView.projectViews.project.getInheritedViews()

        return new Request(this,'POST','project/{0}/view'.f(projectView.projectViews.project.id), {
            settings    : settings,   // we pass settings because at the moment views are calculated on client only (!) and server need them to add a view
            name        : projectView.name,
            systemType  : projectView.systemType,
            userId      : projectView.userId,
            access      : projectView.access,
        })
    }

    static deleteView(projectId: ID, projectViewId: ID) {
        return new Request(this,'POST','project/{0}/view/delete'.f(projectId), {projectViewId})
    }

    static getSummary(projectId: ID) {
        return new Request(this,'GET','project/{0}/summary-counters'.f(projectId))
    }

    // ORIGINAL

    getProject(id:ID) {
        return new Request(this,'GET','project/'+id);
    }

    loadArchived(id:ID) {
        return new Request(this,'GET','project/'+id+'/load-archived');
    }

    // PROJECT VIEWS

    meetings(projectId:ID, startMoment:Moment, endMoment:Moment) {
        return new Request(this,'GET','project/{0}/meetings'.f(projectId), {
            startDate: startMoment.format("YYYY-MM-DD"),
            endDate: endMoment.format("YYYY-MM-DD")
        });
    }

    expenses(projectId:ID) {
        return new Request(this,'GET','project/{0}/expenses'.f(projectId));
    }

    activityStream(projectId:ID, startMoment:Moment, endMoment:Moment) {

        return new Request(this,'GET','project/'+projectId + '/activity-stream',{
            startDate: startMoment.format("YYYY-MM-DD"),
            endDate: endMoment.format("YYYY-MM-DD")
        });
    }

    timelineNew(projectId:ID, dateRange:any, options:any = {}) {
        const { isTag, includeClosed } = options;
        let res;
        if (isTag)
            res = new Request(this,'GET','tag/'+projectId+'/tasks-all');
        else if (includeClosed)
            res = new Request(this,'GET','project/'+projectId+'/workload', {
                startDate: dateRange.start.format("YYYY-MM-DD"),
                endDate: dateRange.end.format("YYYY-MM-DD"),
                showClosed: true,
                timeAllocation: true
            });
        else
            res = new Request(this,'GET','project/'+projectId+'/workload', {
                startDate: dateRange.start.format("YYYY-MM-DD"),
                endDate: dateRange.end.format("YYYY-MM-DD"),
                showClosed: false,
                timeAllocation: true
            });
        return res;
    }

    gantt(projectId:ID, dateRange:any, options:any = {}) {
        // console.trace('!!!gantt', projectId, dateRange, options)

        let res;
        if (options.isTag)
            res = new Request(this,'GET','tag/'+projectId+'/tasks-all');
        else
            res = new Request(this,'GET','project/'+projectId+'/gantt', {
                startDate: dateRange.start.format("YYYY-MM-DD"),
                endDate: dateRange.end.format("YYYY-MM-DD"),
                showClosed: options.showClosed
            });
        return res;
    }

    integrations(id:ID) {
        return new Request(this,'GET','project/'+id+'/integrations');
    }

    updateStatus(projectId:ID, status:ID, forceClose = false) {
        return new Request(this,'put','project/'+projectId+"/status",{
            status: status,
            forceClose: forceClose
        });
    }

    updateSystemStatus(projectId:ID, systemStatus:SystemStatus, forceClose = false) {
        return new Request(this,'put','project/'+projectId+"/status",{
            systemStatus: systemStatus,
            forceClose: forceClose
        });
    }

    updateComment(projectId:ID, comments:string) {

        return new Request(this,'PUT','project/{0}/update'.f(projectId), {
            statusComments: comments
        });
    }

    setDescription(projectId:ID, description:string, descriptionRTF:any) {
        return new Request(this,'PUT','project/'+projectId+'/description',{description, descriptionRTF});
    }

    enableTaskTypes(projectId:ID, taskTypes:any) {
        return this.update(projectId,{
            taskTypes: taskTypes
        })
    }

    updateIntegrationEmail(projectId:ID, access:any, defaultAssignToUserId:any, crmLinkContact:boolean, crmCreateContact:boolean) {
        return new Request(this, 'PUT', 'project/'+projectId+'/integration_email', {
            access,
            defaultAssignToUserId,
            crmLinkContact,
            crmCreateContact
        });
    }

    getUsers(projectId:ID) {
        return new Request(this,'GET','project/'+projectId+'/users');
    }

    getUsersRecursively(projectId:ID) {
        return new Request(this,'GET','project/'+projectId+'/users-recursively');
    }

    // deprecated see project users
    addUsers(projectId:ID, users:any) {
        return new Request(this, 'POST', 'project/'+projectId+'/users-add-many', {
            users: users
        });
    }

    setStatuses(projectId:ID, statusesArray:any[] | null) {
        return this.update(projectId, {
            statuses: statusesArray
        })
    }

    setTasksStatuses(projectId:ID, arrTaskStatuses:any[] | null) {
        const taskStatuses = arrTaskStatuses ? arrTaskStatuses : [];
        return this.update(projectId, {
            taskStatuses: taskStatuses
        })
    }

    setPriority(projectId:ID, priority:number) {
        return new Request(this,'put','project/'+projectId+'/priority',{
            'priority': priority
        });
    }

    getCopyParams(projectId: ID) {
        return new Request(this,'GET','project/'+projectId+'/copy')
    }

    copyProject(projectId:ID, data:any) {
        //data format
        /*{
            toProjectId: result.parentProject,
            name: result.name,
            description: result.description,
            prefix: result.prefix,

            copyTasks: copyOptions.includes("tasks"),
            copyUsers: copyOptions.includes("users"),
            copySubProjects: copyOptions.includes("subprojects"),
            copyEvents: copyOptions.includes("events"),
            copyCustomFields: copyOptions.includes("customFields"),

            planningStartDate: startDate ? startDate.format("YYYY-MM-DD") : null,
            planningEndDate: endDate ? endDate.format("YYYY-MM-DD") : null,

            copyAsTemplate: copyAsTemplate
        }*/

        return new Request(this,'POST','project/'+projectId+'/copy', data);
    }

    saveAsTemplate(projectId:ID, data:any) {
        return new Request(this,'POST','project/'+projectId+'/save-as-template', data);
    }

    copyTemplate(data:any) {
        //data format
        /*{
            templateId: result.templateId,
            name: result.name
        }*/
        return new Request(this,'POST','local_template/copy', data);
    }

    newWorkfolder(data:any) {
        return new Request(this,'POST','new-workfolder',data);
    }

    newProjectWithoutLocalTemplate(data:any) {
        return new Request(this,'POST','new-project-without-local-template', data);
    }

    newProjectFromSharedTemplate(data:any) {
        return new Request(this,'POST','new-project-from-shared-template', data);
    }

    newProjectFromTemplate(data:any) {
        //data format
        /*{
            templateId required
            toCompanyId required
            toProjectId
            name
            prefix

            ownerUserId
            deadline

            planningStartDate
            planningEndDate

            copyTasks
            copySubProjects
            copyEvents
        }*/

        if (data.deadline) {
            data.deadline = data.deadline.format("YYYY-MM-DD");
        }

        if (data.planningStartDate) {
            data.planningStartDate = data.planningStartDate.format("YYYY-MM-DD");
        }

        if (data.planningEndDate) {
            data.planningEndDate = data.planningEndDate.format("YYYY-MM-DD");
        }


        return new Request(this,'POST','new-project-from-template', data);
    }

    delete(projectId:ID) {
        return new Request(this,'DELETE','project/'+projectId);
    }

    newProjectType(companyId:ID, data:any) {
        data.companyId = companyId;
        return new Request(this,'POST','new-project-type', data);
    }

    convertV2(projectId:ID, params: {
        systemType?: ProjectSystemType,
        templateId?: ID
    }) {
        return new Request(this,'PUT','project/'+projectId+'/convert-v2',params)
    }



    convertProject(projectId:ID, data:any) {
        //data format
        /*{
         templateId required
         owner
         }*/

        return new Request(this,'PUT','project/'+projectId+'/convert',data);
    }

    convertToFolder(projectId:ID, data:any) {

        if (!data) data = {};
        data.convertToWorkfolder = true;
        data.templateId = null;

        return new Request(this,'PUT','project/'+projectId+'/convert',data);
    }

    getProjectFiles(projectId:ID, showAllTasksFiles=false) {
        const params:any = {};
        if (showAllTasksFiles) params.showAllTasksFiles = true;
        return new Request(this, 'GET', 'project/'+projectId+'/files', params);
    }

    addFiles(projectId:ID, files:any) {
        return new Request(this, 'POST', 'project/' + projectId + '/files', { files });
    }

    deleteFile(projectId:ID, fileId:ID) {
        return new Request(this, 'POST', 'project/' + projectId + '/files/delete', { fileIds: [fileId] });
    }

    toggleFileStarred(projectId:ID, fileId:ID, isFlagged:boolean) {
        return new Request(this, 'PUT', 'project/' + projectId + '/files', { fileId, isFlagged });
    }

    static saveSettings(projectId:ID, settings:any) {
        return new Request(this, 'PUT', 'project/' + projectId + '/settings', { settings: settings });
    }

    setProperties(projectId:ID, properties:any) {
        return this.update(projectId,{
            properties: properties
        })
        // return new Request(this, 'PUT', 'project/' + projectId + '/settings/properties', { properties: properties });
    }

    getOpenTasks(projectId:ID) {
        return new Request(this,'GET','project/'+projectId+'/tasks-gantt');
    }

    getAllTasks(projectId:ID) {
        return new Request(this,'GET','project/'+projectId+'/tasks');
    }

    getTagTasks(tagId:ID) {
        return new Request(this,'GET','tag/'+tagId+'/tasks-all');
    }

    getProjectNotes(projectId:ID) {
        return new Request(this, 'GET', 'project/' + projectId + '/notes');
    }

    setProgress(projectId:ID,progress:any) {
        return this.update(projectId, {
            progress: progress
        })
    }

    setEstimate(projectId:ID,estimate:any) {
        return new Request(this,'PUT', 'project/'+projectId+"/estimate",{
            estimate: estimate
        });
    }

    setDeadline(projectId:ID,deadlineDate:Moment|null) {
        return new Request(this,'PUT','project/'+projectId+"/deadline",{
            deadline: (deadlineDate)?deadlineDate.format("YYYY-MM-DD"):null
        });
    }

    importTasks(organizationId:ID, projectId:ID, csv:any) {
        let fd = new FormData();
        fd.append( 'csv', csv );
        if (projectId) fd.append( 'projectId', projectId );

        return new Request(this,'upload','company/'+organizationId+'/import/upload',fd);
    }

    // I dont think it's used... staagne not marked as not used in editor
    getEvents(projectId:ID, startMoment:Moment, endMoment:Moment, companyEvents = false, personalEvents = false, taskDeadlines = false) {
        return new Request(this,'GET','project/'+projectId+'/events-new',{
            startDate: gd.utils.momentToDate(startMoment),
            endDate: gd.utils.momentToDate(endMoment),
            companyEvents,
            personalEvents,
            taskDeadlines
        });
    }

    /*getEventsAll(projectId:ID) {
        return new Request(this,'GET','project/'+projectId+'/events');
    }*/

    getEventsAll(projectId:ID, events:any, startDate:Moment, endDate:Moment) {
        return new Request(this,'GET','project/{0}/calendar'.f(projectId), {
            events: events.toString(),
            startDate: gd.utils.momentToDate(startDate),
            endDate: gd.utils.momentToDate(endDate)
        });
    }

    getCalendarData(projectId: ID, events:any, startDate:Moment, endDate:Moment) {
        const params = {
            projectIds  : [projectId],
            eventTypes  : events,
            startDate   : gd.utils.momentToDate(startDate),
            endDate     : gd.utils.momentToDate(endDate)
        }

        return new Request(this,'POST','uds/calendar', params)
    }

    setColor(projectId:ID, color:number) {
        return this.update(projectId, {
            color: color
        })
    }

    setHealth(projectId:ID, health:number) {
        return this.update(projectId, {
            health: health
        })
    }

    updateCustomFieldValue(projectId:ID, customFieldId:ID, value:any) {
        if (!projectId || !customFieldId) return;

        const customField = gd.session.customFields.get(customFieldId);
        return new Request(this,'PUT', 'project/' + projectId + '/custom-field', {
            customFieldId: customFieldId,
            newValue: {
                type: customField.valueType,
                value: !_.isNil(value) ? value : customField.defaultValue
            }
        });
    }

    deleteCustomFieldValue(projectId:ID, customFieldId:ID) {
        if (!projectId || !customFieldId) return;

        return new Request(this,'PUT', 'project/' + projectId + '/custom-field', {
            delete: true,
            customFieldId: customFieldId
        });
    }

    getInfo(projectId:ID) {
        return new Request(this,'GET','project/'+projectId+'/info');
    }

    universalTaskRequest(projectId:ID, systemStatus:UniversalTaskSelectorSystemStatus | null, fields:any) {
        // GET http://{{api-app}}/project/Be3MhR/tasks-new?cid=U48GJt&systemStatus=all&tags&timeReports&taskUsers&projectDeadlines&predecessors&successors

        const params = {
            systemStatus: systemStatus,
        }

        // @ts-ignore
        _.map(fields, (field) => params[field] = true)

        return new Request(this,'GET','project/{0}/tasks-new'.f(projectId), params);
    }

    deleteUser(projectId:ID, userId:ID) {
        return new Request(this,'DELETE','project/{0}/users/{1}'.f(projectId, userId));
    }

    reassignItems(projectId:ID, userId:ID, tasksReassignUserId:ID, eventsReassignUserId:ID, projectReassignUserId:ID) {
        return new Request(this, 'POST', 'project/{0}/reassign-items'.f(projectId), {
            userId,
            tasksReassignUserId,
            eventsReassignUserId,
            projectReassignUserId
        });
    }

    getDiscussions(projectId:ID) {
        return new Request(this,'GET','project/{0}/discussions'.f(projectId), {});
    }

    update(projectId:ID, params:any) {
        return new Request(this,'PUT','project/{0}/update'.f(projectId), params);
    }

    resetTemplateContent(projectId:ID) {
        return new Request(this,'POST','project/{0}/reset-template-content'.f(projectId), {});
    }

    settingsSustomTaskId(projectId:ID, enabled:boolean, projectShortName:string) {
        return new Request(this,'POST','project/{0}/settings/task-short-id'.f(projectId), {
            enabled, projectShortName
        });
    }

}
